import { Heading } from "@otrium/atoms";
import findAlgoliaCategoriesTreeNode from "src/utils/findAlgoliaCategoriesTreeNode";
import { formatName } from "src/utils/formatName";
import { Content } from "src/modules/brands/BrandView.styled";
import { FC, ReactNode } from "react";
import { Locale } from "lib/Intl";
import { Department } from "src/types/department";
import { MultiselectHitType } from "src/types/Algolia";

interface AlgoliaProductListHeader {
  locale: Locale;
  genderId: string;
  department?: Department;
  categorySlug?: string;
  title: ReactNode;
  slug?: string;
  categories?: MultiselectHitType[];
  hideBreadcrumbs?: boolean;
}

const AlgoliaProductListHeader: FC<AlgoliaProductListHeader> = ({
  locale,
  genderId,
  department,
  categorySlug,
  title,
  categories,
  slug,
  hideBreadcrumbs = false,
}) => {
  const categoryTitle = categories
    ? findAlgoliaCategoriesTreeNode(categories, slug || "", "slug")?.name
    : slug?.split("-").join(" ");

  return title || categoryTitle ? (
    <Content>
      {/* {!hideBreadcrumbs && (
        <AlgoliaBreadcrumbs
          locale={locale}
          genderId={genderId}
          department={department}
          categorySlug={categorySlug}
          categories={categories}
          title={title}
        />
      )} */}
      <Heading
        data-testid="page-title"
        as="h1"
        variant="h2"
        fontSize={["20px", "20px", "28px", "28px"]}
        mb={3}
        sx={{
          textTransform: "uppercase",
          letterSpacing: "1.8px",
          fontWeight: "700",
          color: "#000000",
        }}
      >
        {title || formatName(categoryTitle || "")}
      </Heading>
    </Content>
  ) : null;
};

export default AlgoliaProductListHeader;
